import { MerchantsListModule } from '@/components/modules/MerchantsList/MerchantsList';
import { PAGE_MERCHANT_ALLOWED_ROLES } from '@/components/views/DynamicPageView/config/layoutScheme/constants/PageMerchantAllowedRoles';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_MERCHANT_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.MERCHANT_LIST,
  schemesByRoles: [
    {
      roles: PAGE_MERCHANT_ALLOWED_ROLES,
      titleTextId: 'MERCHANTS_LIST_TITLE',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <MerchantsListModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
          showInternalData
        />
      ),
    },
    {
      textId: undefined,
      module: (
        <MerchantsListModule
          permissions={{
            view: [APP_USER_TYPES.LENDER, APP_USER_TYPES.PARTNER, APP_USER_TYPES.MERCHANT_GROUP],
            edit: [],
          }}
        />
      ),
    },
  ],
};
